import React, { useEffect, useState } from 'react';
import { Grid } from "@mui/material";
import TableHeader from 'components/TableHeader/TableHeader';
import TagSchemeDataTable from 'components/DataTable/TagSchemeDataTable';
import { Colors } from "assets/colors";
import RssFeedTwoToneIcon from '@mui/icons-material/RssFeedTwoTone';
import {getAllSchemes} from 'apis/device';
import DeleteTruckModal from "../../components/TruckModal/DeleteTruckModal";
import TagSchemeModal from "../../components/TagSchemeModal/TagSchemeModal";
import CommonUtil from "../../common/CommonUtil";

interface TruckManagerProps {
}

const TagSchmeManager: React.FC<TruckManagerProps> = () => {
  const [searchVal, setSearchVal] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [schemeData, setTagSchemeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [truckToDelete, setTruckToDelete] = useState(null);
  const [deleteTruck, setDeleteTruck] = useState(false);
  const [schemeToEdit, setSchemeToEdit] = useState(null);
  const [err, setErr] = useState("");
  const [page, setPage] = useState(0);
  const [deviceDataAfterFilter, setDeviceDataAfterFilter] = useState([]);

  const getTagSchemeList = async () => {
    setIsLoading(true);
    let data = await getAllSchemes();
    if (data?.response?.data?.errorMessage) {
      setErr(data.response.data.errorMessage);
      return
    }
    console.log(data);
    setTagSchemeData([]);
    if (data && data.length > 0) {
      data.forEach((object: any) => {
        if ('creationDate' in object && object.creationDate !== null) {
          object.creationDate = new Date(object.creationDate).toLocaleString();
        }
        if ('lastUpdateDate' in object && object.lastUpdateDate !== null) {
          object.lastUpdateDate = new Date(object.lastUpdateDate).toLocaleString();
        }
      });
      const sortedArray = data.sort((a: any, b: any) => {
        // Convert the lastUpdateDate strings to Date objects
        const dateA = new Date(a.lastUpdateDate);
        const dateB = new Date(b.lastUpdateDate);

        // Compare the dates and return the result
        if (dateA > dateB) {
          return -1;
        } else if (dateA < dateB) {
          return 1;
        } else {
          return 0;
        }
      });
      setTagSchemeData(sortedArray);
    }

    setIsLoading(false);
  };

  useEffect(() => {
   getTagSchemeList();
  }, [])


  let tableButtons = [
    {
      label: "Add Scheme",
      onClickHandler: () => setShowModal(true),
      buttonStyle: { backgroundColor: Colors.Red, },
      icon: <RssFeedTwoToneIcon sx={{ marginRight: ".5rem" }} />
    }
  ]

  if(!CommonUtil.isScreenButtonAvailable(CommonUtil.TAG_SCHEME_MANAGER,CommonUtil.UPDATE_MODE)){
    tableButtons = [];
  }

  const handleModalAction = async (val: string, data: any) => {
    console.log(val);
    if(val === "deleteTruck") {
      setTruckToDelete(data);
      setDeleteTruck(true);
      setPage(Math.random()*10000);

    }
    if(val === "editTruck") {
      setSchemeToEdit(data);
      setShowModal(true);
    }
  };

  const closeDeleteModal = () => {
    setDeleteTruck(false);
    setTruckToDelete(null);
  }

  useEffect(() => {
    if(!showModal) {
      setSchemeToEdit(null);
      setTruckToDelete(null);
    }
  }, [showModal]);

    // Downloading Only Filtered Data After Search
  const updateFilteredData = (data:[]) => {
    setDeviceDataAfterFilter(data);
  }

  return (
    <Grid container spacing={2}>
       {showModal && <TagSchemeModal open={showModal} handleClose={setShowModal} getTagSchemeist={getTagSchemeList} schemeToEdit={schemeToEdit}/>}
      {truckToDelete !== null && <DeleteTruckModal open={deleteTruck} handleClose={closeDeleteModal} truck={truckToDelete} getTruck={getTagSchemeList}/>}
      <TableHeader actionButtons={tableButtons} searchVal={searchVal} setSearchVal={setSearchVal} data={deviceDataAfterFilter} csvLabel={"tagscheme.csv"}/>
      <Grid item xs={12} sx={{ height: "80vh" }}>
        <TagSchemeDataTable data={schemeData} searchVal={searchVal} openModal={handleModalAction} getFilteredData={updateFilteredData}/>
      </Grid>
    </Grid>
  )
}

export default TagSchmeManager;
